<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <div class="">
            <div class="onboarding-container" style="background-size: cover;" :style="{ backgroundImage: `url(${bgdiamond})` }">
                <br /><br />
                <div style="width:90%;margin:0 auto">
                    <CRow class="align-items-center justify-content-between mt-4 p-0">
                        <CCol class="d-flex align-items-center">
                            <CImg :src="user.filePath" class="profile-avatar me-3" />
                            <div class="ml-2">
                                <h3 class="profile-name text-white m-0 custom-12px-400">Welcome</h3>
                                <p class="profile-username m-0 custom-16px-600 text-white">@{{ user.name }}</p>
                                
                            </div>
                        </CCol>
    
                        <!-- Right: Search & Notification Icons -->
                        <CCol class="d-flex align-items-center justify-content-end">
                            <img src="../assets/img/new/smallicon/search.png" width="30px" class="me-2" />
                            <img src="../assets/img/new/smallicon/noti.png" width="30px" class="ml-2" />
                        </CCol>
                    </CRow>
                    <br />
                  
    
                    <div class="slider-wrapper p-0 relative">
                        <!-- Left Arrow -->
                        <button class="nav-arrow left-arrow" @click="prevSlide" v-if="step > 1">
        ‹
      </button>
    
                        <!-- Right Arrow -->
                        <button class="nav-arrow right-arrow" @click="nextSlide" v-if="step < screens.length">
        ›
      </button>
    
                        <!-- Slider Content -->
                        <div class="slider p-2" :style="sliderStyle">
                            <div v-for="(screen, index) in screens" :key="index" class="slide p-2" :class="{ 'active-slide': index === step - 1 }">
                                <div class="image-container">
                                    <img :src="screen.filePath" class="onboarding-image" />
                                    <div class="overlay">
                                        <span class="badge">Limited Offer!</span>
                                        <h3 class="overlay-title">{{ screen.Name }}</h3>
                                        <p class="overlay-text">{{ screen.Amount }}</p>
                                        <button class="overlay-btn" @click="GoToSurvey(screen.codeQuestion)">Start Survey</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- Pagination Dots -->
                    <div class="pagination mb-2">
                        <span v-for="(screen, index) in screens" :key="index" :class="{ active: index + 1 === step }" @click="goToStep(index + 1)"></span>
                    </div>
                    <br /><br />
                </div>
            </div>
            <div class="w-100">
                <div style="margin:0 auto">
                    <div fluid class="custom-half-border">
                        <div>
                            <h3 class="custom-14px-500 font-color-171717 text-center d-lg-none d-md-none">
                                Type of Industries
                            </h3>
                            <h3 class="custom-40px-600 font-color-171717 text-center d-sm-down-none mb-3">
                                Type of Industries
                            </h3>
                            <br />
                            <!-- <input type="file" ref="fileInput" multiple @change="handleFileSelect"/> -->
                            <CRow class="justify-content-start text-center d-flex flex-nowrap">
                                <CCol v-for="(item, index) in industries" :key="index" class="d-flex flex-column align-items-center p-2 flex-shrink-0" style="width: 100px;" @click="GoToIndustries(item.Id)">
    
                                    <div class="icon-container">
                                        <img :src="item.filePath" style="max-width:100%" />
                                    </div>
                                    <h3 class="custom-12px-500 font-color-171717 mt-2 text-center">
                                        {{ item.Category }}
                                    </h3>
                                </CCol>
                            </CRow>
                        </div>
                    </div>
                </div>
            </div>

            <section class="hero-card">
                <div class="hero-card__inner">
                    <!-- Left: copy -->
                    <div class="hero-card__copy">
                    <h2 class="hero-card__title">
                        Discover How<br/>Surpriz.ing Works!
                    </h2>
                    <p class="hero-card__subtitle">
                        Your opinions. Your rewards. Your<br/>voice, valued.
                    </p>
                    <button class="hero-card__cta" @click="GoToSurvey('')">Play Now</button>
                    </div>

                    <!-- Right: visual stack -->
                    <div class="hero-card__visual">
                    <!-- vector background -->
                    <img :src="vectorBg" class="hero-card__vector" alt="" aria-hidden="true" />
                    
                    <!-- phone image -->
                    <img :src="phoneImg" class="hero-card__phone" alt="App preview on phone" />
                    </div>
                </div>
            </section>


    
           
    
            <div class="w-100">
                <!-- Title and "See all" link -->
    
    
                <!-- Card List -->
                <!-- <CRow class="mt-2 d-flex overflow-auto flex-nowrap p-2" style="scroll-snap-type: x mandatory;">
                            <CCol v-for="(review, index) in reviews2" :key="index" class="flex-shrink-0 px-2 pl-3 pr-2" style="scroll-snap-align: start; min-width: 100%;">
                                <CCard class="custom-border-white shadow-sm rounded-3 w-100">
                                    <div class="position-relative">
                                        <img :src="review.image" class="w-100 rounded-3" style="border-top-left-radius: 10px; border-top-right-radius: 10px;" />
                                    </div>
                                    <div class="p-2">
                                        <h4 class="custom-14px-700 font-color-0A0A0A mt-2">{{ review.title }}</h4>
                                        <p class="custom-12px-500 text-muted">Organized by {{ review.organizer }}</p>
                                        <div class="d-flex align-items-center text-muted flex-wrap justify-content-between">
                                            <span class="d-flex align-items-center">
                                                <CIcon name="cil-clock" size="sm" class="me-1 mr-2" />
                                                {{ review.duration }} min
                                            </span>
                                            <span class="d-flex align-items-center">
                                                <img src="../assets/img/new/voucher.png" class="me-1 mr-2" width="12px" />
                                                E-voucher
                                            </span>
                                        </div>
                                        <CButton color="light" class="w-100 mt-3 text-primary border-primary bg-white">
                                            Start Survey
                                        </CButton>
                                    </div>
                                </CCard>
                            </CCol>
                        </CRow> -->
                <div style="width:90%;margin:0 auto">
                    <div class="d-flex">
    
                        <h3 class="custom-14px-500 font-color-171717 text-left d-lg-none d-md-none">
                            Top Review
                        </h3>
                        <h3 class="custom-40px-600 font-color-171717 text-left d-sm-down-none mb-3">
                            Top Review
                        </h3>
                    </div>
                    <CRow class="mt-2 d-flex overflow-auto flex-nowrap p-2 responsive-slider" style="scroll-snap-type: x mandatory;">
                        <CCol v-for="(review, index) in reviews2" :key="index" class="flex-shrink-0 px-2 pl-3 pr-2 review-slide">
                                <CCard class="custom-border-white shadow-sm rounded-3 w-100">
                                    <div class="position-relative">
                                        <img :src="review.image" class="w-100 rounded-3" style="border-top-left-radius: 10px; border-top-right-radius: 10px;" />
                                    </div>
                                    <div class="p-2">
                                        <h4 class="custom-14px-700 font-color-0A0A0A mt-2">{{ review.title }}</h4>
                                        <p class="custom-12px-500 text-muted">Organized by {{ review.organizer }}</p>
                                        <div class="d-flex align-items-center text-muted flex-wrap justify-content-between">
                                            <span class="d-flex align-items-center">
                                                <CIcon name="cil-clock" size="sm" class="me-1 mr-2" />
                                                {{ review.duration }} min
                                            </span>
                                            <span class="d-flex align-items-center">
                                                <img src="../assets/img/new/voucher.png" class="me-1 mr-2" width="12px" />
                                                E-voucher
                                            </span>
                                        </div>
                                        <CButton color="light" class="w-100 mt-3 text-primary border-primary bg-white">
                                            Start Survey
                                        </CButton>
                                    </div>
                                </CCard>
                            </CCol>
                        <!-- <CCol v-for="(review, index) in reviews2" :key="index" class="flex-shrink-0 px-2 pl-3 pr-2 review-slide">
                            <CCard class="custom-border-white shadow-sm rounded-3 w-100">
                                <div class="position-relative">
                                    <img 
  :src="review.image" 
  class="w-100 rounded-top image-fixed-height" 
/>
                                </div>
                                <div class="p-2">
                                    <h4 class="custom-14px-700 font-color-0A0A0A mt-2">{{ review.title }}</h4>
                                    <p class="custom-12px-500 text-muted">Organized by {{ review.organizer }}</p>
                                    <div class="d-flex align-items-center text-muted flex-wrap justify-content-between">
                                        <span class="d-flex align-items-center">
                                                <CIcon name="cil-clock" size="sm" class="me-1 mr-2" />
                                                {{ review.duration }} min
                                            </span>
                                        <span class="d-flex align-items-center">
                                                <img src="../assets/img/new/voucher.png" class="me-1 mr-2" width="12px" />
                                                E-voucher
                                            </span>
                                    </div>
                                    <CButton
                                        color="light"
                                        class="w-100 mt-3 text-primary border-primary bg-white"
                                        @click="openVideoModal(review.video)"
                                        >
                                        Watch Review
                                    </CButton>

                                </div>
                            </CCard>
                        </CCol> -->
                    </CRow>
                </div>
                <br /><br /> <br /><br />
            </div>

            <!-- Top Review header -->
            <div class="top-reviews">
                <div class="section-header">
                    <h3>5 Top Review</h3>
                    <button class="see-all" @click="goToTopReviews">See all</button>
                </div>

                <!-- Top Review list -->
                <div class="review-list">
                    <div
                    v-for="item in topReviews"
                    :key="item.id"
                    class="review-card"
                    @click="openPlace(item)"
                    >
                    <div class="avatar"></div>

                    <div class="review-content">
                        <div class="rating-row">
                        <span class="star">★</span>
                        <span class="rating">{{ item.rating }}</span>
                        <span class="out-of">/5</span>
                        </div>

                        <div class="place-name">{{ item.name }}</div>

                        <!-- still styled the same -->
                        <button 
                        class="ghost-chip"
                        @click.stop="openPlace(item)">
                        See {{ item.count }} Top Review
                        </button>
                    </div>
                    </div>
                </div>
            </div>

            <Footerlayout class="d-block d-md-none"></Footerlayout>
        </div>

        <div v-if="showModal" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <div class="text-right">
                        <CButton class="close-btn" @click="isPopupClose()">X</CButton>
                    </div>
                    <video
                        v-if="selectedVideo"
                        :src="selectedVideo"
                        controls
                        autoplay
                        style="width: 100%; height: auto; border-radius: 10px;"
                        />
                </div>
                </div>
    
        <!-- <CModal
      title="Video Review"
      size="lg"
      :show.sync="showModal"
      @close="showModal = false"
      centered
    >
    <video
      v-if="selectedVideo"
      :src="selectedVideo"
      controls
      autoplay
      style="width: 100%; height: auto; border-radius: 10px;"
    />
    </CModal> -->

    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurplerectangle.png";
import bgdiamond from "../assets/img/new/bgdiamond.jpeg";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import Footerweb from "../containers/FooterWeb.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";
import avatar from "@/assets/img/defaultusercartoon.png";
import phoneImg from '@/assets/img/PhoneImg.png'
import vectorBg from '@/assets/img/VectorApp.svg'


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        Footerweb
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,
            bgdiamond,
            step: 1,
            phoneImg,
            vectorBg,
            screens: [],
            user: {
                filePath: avatar,
                name: "Guest",
                username: "user.os",
                bio: "Dream big, work hard, stay focused, and surround yourself with good energy. 💪",
                posts: 24,
                following: 490,
                followers: "12.8k",
            },
            categories: [
                { imgSrc: require('@/assets/img/new/scan.png'), label: 'Scan' },
                { imgSrc: require('@/assets/img/new/fb.png'), label: 'F&B' },
                { imgSrc: require('@/assets/img/new/hospitality.png'), label: 'Hospitality' },
                { imgSrc: require('@/assets/img/new/edu.png'), label: 'Education' },
                { imgSrc: require('@/assets/img/new/services.png'), label: 'Services' }
            ],
            reviews: [
                { title: "Marketing Review Brand A", time: "5 min", type: "E-voucher" },
                { title: "Strategy Review Brand B", time: "10 min", type: "Discount" },
                { title: "Advertising Review Brand C", time: "7 min", type: "Cashback" },
                { title: "Product Review Brand D", time: "12 min", type: "Coupon" },
            ],
            reviewStep: 1, // Step for Reviews Slider
            onboardingStep: 1, // Step for Onboarding Slider

            reviews2: [{
                    title: "Service Review of every Honda showroom and repair sho..",
                    organizer: "Toyota",
                    duration: 5,
                    image: require('@/assets/img/new/re1.jpg'), // Replace with real image
                    video: '' // Replace with real image
                },
                {
                    title: "Service Review of every Proton showroom and repair sho..",
                    organizer: "Proton",
                    duration: 7,
                    image: require('@/assets/img/new/re2.jpg'),
                    video: '' // Replace with real image
                },
                {
                    title: "Service Review of every Mazda showroom and repair sho..",
                    organizer: "Mazda",
                    duration: 5,
                    image: require('@/assets/img/new/re3.jpg'),
                    video: '' // Replace with real image
                },
                {
                    title: "Service Review of every Proton showroom and repair sho..",
                    organizer: "Proton",
                    duration: 5,
                    image: require('@/assets/img/new/re1.png'),
                    video: '' // Replace with real image
                }
            ],
            topReviews: [
                { id: 1, name: 'Restoran Yusoof dan Zakhir', rating: 5, count: 5 },
                { id: 2, name: 'Rebung Kuala Lumpur', rating: 5, count: 3 },
                { id: 3, name: 'Nasi Kandar Pelita', rating: 4.5, count: 6 }
                ],
            uploadedFiles: [],
            industries: [],
            feed: [],
            allreview: [],
            //reviews2: [],
            selectedVideo: null,
            showModal: false




        };
    },
    computed: {
        sliderStyle() {
            let slidesPerView = 1; // Default for mobile

            if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                slidesPerView = 2; // Tablet (2 per slide)
            } else if (window.innerWidth >= 1024) {
                slidesPerView = 3; // Desktop (3 per slide)
            }

            return {
                transform: `translateX(-${(this.step - 1) * (100 / slidesPerView)}%)`,
                transition: 'transform 0.5s ease-in-out'
            };
        },
        reviewSliderStyle() {
            return {
                transform: `translateX(-${(this.reviewStep - 1) * 100}%)`,
            };
        },
        onboardingSliderStyle() {
            return {
                transform: `translateX(-${(this.onboardingStep - 1) * 100}%)`,
            };
        },
        reviewsPagination() {
            let itemsPerPage = window.innerWidth <= 1024 ? 2 : 3; // 2 items for tablets, 3 for desktop
            return Array(Math.ceil(this.reviews.length / itemsPerPage)).fill(null);
        },
        screensPagination() {
            return Array(this.screens.length).fill(null);
        },
    },
    created() {
        AOS.init();

    },
  

    async mounted() {
        try {
            // Check if the user is authorized
            const isAuth = await this.UserAuth();
            
            if (isAuth) {
                // If authenticated, get the user details
                this.GetListVoucher();
            this.GetListIndustries();
            this.GetListFeedback();
            this.GetInfoUser();
            this.GetAllReviewVoucher();
            } else {
                // If not authenticated, set the user to "Guest" and redirect to login page
                this.user = {
                    name: "Guest",
                    avatar: "/path/to/default/avatar.jpg",  // Default avatar for guest
                    username: "guest",
                    bio: "Welcome to our platform!",
                };
                this.GetListVoucher();
                this.GetListIndustries();
                this.GetListFeedback();
                this.GetAllReviewVoucher();
            }
        } catch (error) {
            // Handle error, and ensure to redirect if there's an issue
            console.error("Error during authentication:", error);
            this.GetListVoucher();
            this.GetListIndustries();
            this.GetListFeedback();
            this.GetAllReviewVoucher();

        }
    },

    methods: {
        goToTopReviews() {
            this.$router.push({ name: 'TopReviews' })
        },

        openPlace(item) {
            console.log("Clicked:", item.name);

            // Navigate to TopReviews page, pass the placeId or name
            this.$router.push({
            name: 'TopReviews',
            query: { placeId: item.id }   // <-- attach ID here
            })
        },
        GoToEvoucher() {
            this.$router.push("SelectionEvoucher");
        },
        nextStep() {
            let slidesPerView = window.innerWidth >= 768 && window.innerWidth <= 1024 ? 2 : 1;
            if (this.step < this.screens.length - slidesPerView + 1) {
                this.step += slidesPerView;
            }
        },
        goToStep(index) {
            this.step = index;
        },
        GoToIndustries(id) {
            this.$router.push("DetailIndustries" + "?id=" + id);
        },
        goToReviewStep(step) {
            this.reviewStep = step;
        },
        goToOnboardingStep(step) {
            this.onboardingStep = step;
        },
        GoToSurvey(code) {
            if (code != '') {
                this.$router.push("HomeSurvey?code=" + code);

            } else {
                this.$router.push("HomeSurvey");

            }

        },
        async GetListVoucher() {
            try {
                const response = await this.$API.get(this.$GetListControlVoucherShow, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.screens = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListIndustries() {
            try {
                const response = await this.$API.get(this.$GetListIndustries, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.industries = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        handleFileSelect(event) {
            const files = Array.from(event.target.files);
            this.processFiles(files);
        },
        handleDrop(event) {
            event.preventDefault();
            const files = Array.from(event.dataTransfer.files);
            this.processFiles(files);
        },
        processFiles(files) {
            files.forEach((file) => {
                if (file.size <= 10 * 1024 * 1024) { // 10MB Limit
                    // Add the file to uploadedFiles only once, before uploading
                    if (!this.uploadedFiles.some(f => f.name === file.name)) {
                        this.uploadedFiles.push({ name: file.name, uploading: true });
                        this.uploadFile(file); // Start the upload for this file
                    }
                } else {
                    alert("File size exceeds 10MB!");
                }
            });
        },
        async uploadFile(file) {
            const formData = new FormData();
            formData.append("file", file);

            console.log("Uploading file:", file.name);

            try {
                const response = await this.$API.post(this.$UploadAnyFile, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    withCredentials: true,
                });

                if (response.status === 200) {
                    console.log("File uploaded successfully:", file.name);
                    this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== file.name);
                } else {
                    console.error("Failed to upload file:", response);
                }
            } catch (error) {
                console.error("Upload error:", error);
            }
        },
        nextSlide() {
            if (this.step < this.screens.length) {
            this.step++;
            }
        },
        prevSlide() {
            if (this.step > 1) {
            this.step--;
            }
        },
        goToStep(index) {
            this.step = index;
        },
        async GetListFeedback() {
            try {
                const response = await this.$API.get(this.$ListAppFeedback);
                if (response.status === 200) {
                    this.feed = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetInfoUser() {
        try {
            const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
            if (response.status === 200 && response.data) {
                this.user = response.data;
            } else {
                // Handle failure to get user info if needed
                console.error("Failed to fetch user info");
                this.user = {
                    name: "Guest",
                    avatar: "/path/to/default/avatar.jpg",
                    username: "guest",
                    bio: "Welcome to our platform!",
                };
            }
        } catch (error) {
            console.error("Error fetching user information:", error);
            this.user = {
                name: "Guest",
                avatar: "/path/to/default/avatar.jpg",
                username: "guest",
                bio: "Welcome to our platform!",
            };
        }
    },
    async GetAllReviewVoucher() {
        try {
            const response = await this.$API.get(this.$GetDetailVoucherAllCompany);
            if (response.status === 200) {
            const rawData = response.data;

            // Flatten and filter the data: only include users with valid video URLs
                this.reviews3 = rawData.flatMap(item =>
                item.users
                .filter(user => user.video) // Only include if video exists
                .map(user => ({
                    image: user.profilePhoto,
                    title: user.codeVoucher,
                    organizer: user.name,
                    duration: 2, // Adjust duration logic if needed
                    video: user.video
                }))
                );
            } else {
            console.error("Failed to fetch review data:", response);
            }
        } catch (error) {
            console.error("Error fetching review data:", error);
        }
        },
        openVideoModal(videoUrl) {
            this.selectedVideo = videoUrl;
            this.showModal = true;
        },
        isPopupClose()
        {
            this.showModal = false;
            this.selectedVideo = null; 
        }

    }


};
</script>


<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height: 90vh;
}

.salary-range {
    padding: 20px;
}

.progress {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #007bff;
}

.custom-range {
    width: 100%;
}

.input-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

input[type="text"].custom {
    padding-right: 60px;
    /* Adjust according to button width */
    height: 80px;
}

.verify-button {
    position: absolute;
    right: 2px;
    top: 3px;
    bottom: 3px;
    height: 28px;
    border-radius: 50px;
    background: #928AFD;
    color: #fff;
    /* Optional: Adjust the button height to match the input field */
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.onboarding-container {
    margin: auto;
    padding: 10px;
}

.slider-wrapper {
    overflow: hidden;
    width: 100%;
}

.slider {
    display: flex;
    transition: transform 0.5s ease-in-out;
    white-space: nowrap;
    align-items: stretch;
    /* Ensures all slides have the same height */
}

.slide::before {
    display: none !important;
}

.slide {
    min-width: 100%;
    padding: 10px;
    transition: opacity 0.5s, transform 0.5s;
    height: 100%;
    /* Ensure all slides remain the same height */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    opacity: 1 !important;
}

@media (min-width: 1024px) {
    .slide {
        min-width: calc(100% / 3);
        /* Each slide takes 1/3 of the container */
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .slide {
        min-width: 50%;
        /* Show 2 items per slide */
    }
}

.active-slide {
    opacity: 1;
    transform: scale(1);
    /* Ensure the active slide does not change in size */
}

.slide:not(.active-slide) {
    opacity: 0.6;
    /* Dim non-active slides */
    transform: scale(1);
    /* Keep all slides the same size */
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* Ensure the image container takes full height */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.onboarding-image {
    width: 100%;
    height: 200px;
    /* Make all images the same height */
    border-radius: 10px;
    object-fit: cover;
    /* Ensures the image maintains proportion */
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Dark overlay */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    border-radius: 10px;
    color: white;
}

.badge {
    background: #fff;
    color: #928AFD;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 8px;
    font-weight: 600;
}


.pagination {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.pagination span {
    width: 10px;
    height: 10px;
    background: #ccc;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
}

.pagination span.active {
    background: #fff;
}

.profile-container {
    background: white;
    padding: 20px;
}

.profile-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.profile-name,
.profile-username,
.profile-bio {
    text-align: left;
    margin-left: 20px;
    width: max-content;
}

.stats-row p {
    font-size: 12px;
    /* Adjust to a smaller size */
    white-space: nowrap;
    /* Prevent text from breaking into a new line */
}

.profile-tabs {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #f5f5f5;
    border-radius: 20px;
    padding: 5px;
}

.tab-row {
    width: 100%;
}

.tab-col {
    display: flex;
    width: 100%;
}

.tab-col button {
    flex: 1;
    /* Makes both tabs take equal space */
    padding: 10px;
    text-align: center;
    border: none;
    background: transparent;
    transition: background 0.3s ease-in-out;
    font-weight: bold;
    color: #171717;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.tab-col button img {
    margin-right: 5px;
}

.tab-col button.active-tab {
    background: white;
    border-radius: 20px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.icon-container {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.top-reviews {
  width: 90%; margin:0 auto; margin-bottom:90px;
}
.section-header {
  display:flex; align-items:center; justify-content:space-between;
  margin: 20px 0 10px;
}
.section-header h3 { font-size: 16px; font-weight:600; color: #0A0A0A;}
.see-all {
    background:none; border:none; color:#7970EF; font-weight:400; padding:0;
}

.review-list { display:flex; flex-direction:column; gap:14px; }
.review-card {
  display:flex; gap:14px; padding:14px;
  border:1px solid #eee; border-radius:16px; background:#fff;
  box-shadow:0 2px 8px rgba(0,0,0,.03);
}

.avatar {
  width:48px; height:48px; border-radius:50%;
  background:#e9e9ee;
  flex: 0 0 48px;
}
.review-content { flex:1; min-width:0; }

.star {
  width: 21px;
  height: 21px;
  vertical-align: middle;
  color: #F79009;
}
.rating-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.rating {
  font-weight: 600;
  color: #191919;
}
.out-of {
  color: #666;
  font-size: 14px;
}


.place-name {
  font-size:16px; font-weight:500; margin-bottom:6px;
  overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
  color: #040607;
}
.ghost-chip {
  border:none; background:#f0edff; color:#928AFD;
  padding:6px 10px; border-radius:10px; font-weight:400; font-size:12px;
}


/* Banner */
/* ---- HERO LAYOUT ---- */
.hero-card{
  background: #928AFD;
  border-radius:28px;
  overflow:hidden;
  padding: clamp(14px, 2vw, 24px);
  margin: 16px 20px;
}

/* always a ROW, never stacks */
.hero-card__inner{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: clamp(8px, 1.8vw, 24px);
  flex-wrap:nowrap;                 /* prevent wrapping */
}

/* LEFT: copy */
.hero-card__copy{
  flex: 1 1 52%;                    /* take ~half */
  color:#fff;
  min-width:0;                      /* prevent overflow */
}
.hero-card__title{
  margin:0 0 12px;
  line-height:1.1;
  font-weight:700;
  font-size: clamp(18px, 3.4vw, 44px);
}
.hero-card__subtitle{
  margin:0 0 22px;
  font-weight:500;
  opacity:.95;
  font-size: clamp(11px, 2vw, 20px);
}
.hero-card__cta{
  background:#fff;
  color:#7D6CF0;
  border:0;
  border-radius:999px;
  padding: 6px 16px;
  font-weight:600;
  font-size: clamp(12px, 1.6vw, 16px);
  box-shadow:0 8px 20px rgba(0,0,0,.08);
}

/* RIGHT: vector behind phone */
.hero-card__visual{
  flex: 1 1 48%;
  position:relative;
  height: clamp(180px, 32vw, 360px); /* controls whole block height */
  display:grid;
  place-items:center;
}

.hero-card__vector{
    position:absolute;
    width: 135%;
    max-width: 520px;
    left: -27%;
    top: -8%;
    z-index:0;
    pointer-events:none;
}
.hero-card__phone {
  position: relative;
  max-width: 87%;
  height: auto;                   /* maintain aspect ratio */
  max-height: 360px;
  /* z-index: 1; */
  object-fit: contain;            /* ensures no stretching or cropping */
}




@media (min-width: 992px) {
    /* Adjusts for desktop screens (≥992px) */
    .custom-half-border {
        padding: 4rem 2rem;
        /* Increase padding for bigger appearance */
    }
    .icon-container img {
        width: 80px !important;
        /* Increase icon size */
    }
    .custom-12px-500 {
        font-size: 16px !important;
        /* Increase text size */
    }
}

@media (max-width: 991px) {
    /* Keeps smaller sizes for tablets/mobile */
    .custom-half-border {
        padding: 2rem 1rem;
    }
    .icon-container img {
        width: 60px;
    }
    .custom-12px-500 {
        font-size: 12px;
    }
}

@media (min-width: 1024px) {
    .grid-container {
        grid-template-columns: repeat(4, 1fr);
        /* 4 columns per row */
    }
}

.responsive-slider {
    scroll-snap-type: x mandatory;
}

.review-slide {
    scroll-snap-align: start;
    min-width: 100%;
    /* Default: 1 item per slide */
}

/* For Desktop: Show 3 items per slide */

@media (min-width: 992px) {
    .review-slide {
        min-width: calc(100% / 3);
        /* Each slide takes 1/3 of the container */
    }
}

@media (max-width: 767px) {
    .overlay-text {
        font-size: 14px;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .review-slide {
        flex: 0 0 50% !important;
        /* Force it to take 50% */
        max-width: 50% !important;
    }
}
.nav-arrow {
  position: absolute;
  top: 35%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 1.2rem; /* smaller font size */
  border: none;
  cursor: pointer;
  z-index: 10;
  padding: 0.3rem 0.6rem; /* smaller padding */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}

.nav-arrow:hover {
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
